import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useApplicationNotifications } from '@adc/ui-adc'
import EventAssetsActions from '../actions/assets'
import EventPanel from '../components/eventPanel'
import EventProvider from '../providers/event'
import types from '../constants/event.propTypes'
import STATICS from '../event.statics'

const defaultErrorOptions = {
  role: 'error',
  title: STATICS.DEFAULT_ERROR_TITLE,
  message: STATICS.DEFAULT_ERROR_BODY,
  dismissible: true,
}

const EventDetails = ({
  event,
  total,
  offset,
  listings,
  isLoggedIn,
  fetchAssetsAction,
  fetchAssetsProgress = null,
  fetchAuctionInventoryAction,
  featureFlags,
}) => {
  const notifications = useApplicationNotifications()
  return (
    <EventPanel
      event={event}
      listings={listings}
      total={total}
      offset={offset}
      isLoggedIn={isLoggedIn}
      fetchAssetsProgress={fetchAssetsProgress}
      fetchAssetsAction={params =>
        fetchAssetsAction({
          ...params,
          hasAuthenticatedUser: isLoggedIn,
        }).catch(() => {
          notifications.overlayBanner?.open(defaultErrorOptions)
        })
      }
      fetchAuctionInventoryAction={(eventCode, includeCreditBidRevealed) =>
        fetchAuctionInventoryAction(eventCode, includeCreditBidRevealed).catch(
          () => {
            notifications.overlayBanner?.open(defaultErrorOptions)
          }
        )
      }
      featureFlags={featureFlags}
    />
  )
}

EventDetails.propTypes = {
  event: PropTypes.object.isRequired,
  listings: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  fetchAssetsAction: PropTypes.func.isRequired,
  fetchAssetsProgress: types.baseProgressType,
  fetchAuctionInventoryAction: PropTypes.func.isRequired,
  featureFlags: PropTypes.object,
}

function mapStateToProps(store) {
  return {
    event: store.event.event,
    total: store.assets.total,
    offset: store.assets.offset,

    // NOTE: This is a newer prop and is the new reference we should expect all new component additions to use when
    // extending logic
    listings: store.assets,

    isLoggedIn: store.user && store.user.logged_in,
    fetchAssetsProgress: store.assets.fetchAssetsProgress,
    featureFlags: store.featureFlags,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAssetsAction: params =>
      dispatch(EventAssetsActions.fetchAssets(null, params)),
    fetchAuctionInventoryAction: (eventCode, includeCreditBidRevealed) =>
      EventProvider.fetchAuctionInventory(eventCode, includeCreditBidRevealed),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDetails)
